import { Pipe, PipeTransform } from '@angular/core';
import { TagStructred } from '@atpco/hub-ui';

@Pipe({
  name: 'listToTag'
})
export class ListToTagPipe implements PipeTransform {
  transform(
    list: any[],
    idKey: string = 'id',
    nameKey: string = 'name',
    shortNameKey: string = 'shortName',
    descriptionKey: string = 'description',
  ): TagStructred[] {
    if (!Array.isArray(list)) {
      return [];
    }

    const structuredList = list
      .map(item => this.toTag(item, idKey, nameKey, shortNameKey, descriptionKey))
      .filter((item): item is TagStructred => !!item);
    return structuredList;
  }

  private toTag(
    item: any,
    idKey: string,
    nameKey: string,
    shortNameKey: string,
    descriptionKey: string,
  ): TagStructred | null {
    if (item === null || item === undefined) {
      return null;
    }

    if (typeof item === 'string' || typeof item === 'number') {
      const label = String(item);
      return {
        id: label,
        name: label,
        shortName: label,
        description: label,
      };
    }

    const idValue = this.pickValue(item, idKey, ['id', 'code', 'value', 'key', 'name']);
    const nameValue = this.pickValue(item, nameKey, ['name', 'label', 'text', 'code'])
      ?? (idValue !== undefined ? String(idValue) : '');

    return {
      id: idValue,
      name: nameValue,
      shortName: this.pickValue(item, shortNameKey, ['shortName']) ?? nameValue,
      description: this.pickValue(item, descriptionKey, ['description']) ?? nameValue,
    };
  }

  private pickValue(item: any, primaryKey: string, fallbacks: string[] = []): any {
    if (primaryKey && item[primaryKey] !== undefined) {
      return item[primaryKey];
    }

    for (const key of fallbacks) {
      if (item[key] !== undefined) {
        return item[key];
      }
    }

    return undefined;
  }
}
